import {motion} from 'framer-motion'
// Styles
import styles from './badge.module.scss'

const VARIANTS = {
  // eslint-disable-next-line array-bracket-newline
  bounce: {scale: [1, 1.5, 1]},
  rest: {scale: 1},
}

interface BadgeProps {
  previousValue?: number
  value: number
  backgroundColor?: string
  size?: number
}

const Badge = ({
  previousValue = 0,
  value,
  backgroundColor = '#33ff33',
  size = 1,
}: BadgeProps) => {
  const fontSize = 12 * size
  const dimension = 20 * size

  const hasNewValue = previousValue && (value !== previousValue)

  return (
    <motion.div
      animate={hasNewValue ? 'bounce' : 'rest'}
      initial={false}
      variants={VARIANTS}
      transition={{duration: 0.5}}
      className={styles['badge']}
      style={{
        backgroundColor: `${backgroundColor}`,
        height: `${dimension}px`,
        fontSize: `${fontSize}px`,
        borderRadius: `${dimension / 2}px`,
      }}
    >
      <span>{value}</span>
    </motion.div>
  )
}

export default Badge
